import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './lang/i18n'

// 第三方组件
import VueClipboard from 'vue-clipboard2'
import vcolorpicker from 'vcolorpicker'
import store from './store/index'
import Print from 'vue-print-nb'
import Viewer from 'v-viewer'
import VueScroller from 'vue-scroller'
import 'viewerjs/dist/viewer.css'
import 'view-design/dist/styles/iview.css'

import './assets/js/init'

// 挂载组件到vue实例
Vue.use(VueClipboard)
Vue.use(VueScroller)
Vue.use(vcolorpicker)
Vue.use(Viewer)
Vue.use(Print)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js